'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
const formatGroupLabel = exports.formatGroupLabel = group => group.label;

const getOptionLabel = exports.getOptionLabel = option => option.label;

const getOptionValue = exports.getOptionValue = option => option.value;

const isOptionDisabled = exports.isOptionDisabled = option => !!option.isDisabled;